<template lang="pug">
 .t-content
  section.info-sec
    .max-container
      .gbox-wrap.slot.aaa
        .gbox
          div
            b.text-start.text-white.p-title {{$t('ui.partner_title')}}
          template(v-if="$helpers.timingControl('2025-05-16 12:00')")
            .ggl
              a(href='https://dolphinreef88.com/RF13386232' target="_blank")
                img(src='/images/partner/dolphinreef.jpg')
              span Dolphinreef88
            .ggl
              a(href='https://megah5.org/RF12599995' target="_blank")
                img(src='/images/partner/meganew.jpg')
          template(v-else)
            .ggl
              a(href='https://megah5.org/RF12599995' target="_blank")
                img(src='/images/partner/megah5.jpg')
              span MegaH5
          .ggl
            a(href='https://jadiking88.org/RF12010273' target="_blank")
              img(src='/images/partner/jadiking2.jpg')
            span JADIKING 2.0
          .ggl
            a(href='https://epicwin44.com/RF11563559' target="_blank")
              img(src='/images/partner/epicnew.jpg')
            span EpicWin
          .ggl
            a(href='https://whatsapp888.co/RF10350931' target="_blank")
              img(src='/images/partner/whatsapp888.png')
            span WHATSAPP888
          .ggl
            a(href='https://ikea888.com/RF8901927' target="_blank")
              img(src='/images/partner/ikea888.png')
            span IKEA888
          .ggl
            a(href='https://perodua888.com/RF7708919' target="_blank")
              img(src='/images/partner/perodua888.png')
            span PERODUA888
          .ggl
            a(href='https://jadiking8.vip/RF53A02A7' target="_blank")
              img(src='/images/partner/jadiking.png')
            span JADIKING
</template>
<script>
// import topbar from '@/views/default/_topBar.vue'
import { EventBus } from '@/event-bus';

export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  created(){
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/partners');
  },
  mounted(){
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    toPartner(target){
      window.open(target, "_blank")
    },
  }
}
</script>
<style lang="scss" scoped>
.iimg{
  cursor: pointer;
}
.p-title{
  font-size: 16px;
}
</style>